import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const REFRESH = gql(`
mutation UserRefreshSession {
    userRefreshSession {
        jwt
        refreshToken
        userId
        email
    }
}
`);

export default function useRefreshTokenQuery() {
    const [mutateRefresh, { loading, error }] = useMutation(REFRESH);
    const refresh = useCallback(() => mutateRefresh(), [mutateRefresh]);

    return {
        loading,
        error,
        refresh,
    };
}
